var exports = {
  "M": "VerifiedIcon__LIYK9o",
  "J": "Label__hiMokc",
};

module.exports = exports;
